import React from 'react';

function NotFound(props) {
  return (
    <div className="dashboard-wrapper">
      Page not found!
    </div>
  )
}

export default NotFound